import { showMessage } from "./showMessage";
import Cookies from "js-cookie";

export const storeData = (storageKey: any, value: any) => {
  try {
    const cookieData = value;
    Cookies.set(storageKey, cookieData);
  } catch (e) {
    showMessage("Gagal menyimpan data di storage", "error");
  }
};

export const getData = (storageKey: any) => {
  try {
    const cookieData = Cookies.get(storageKey);
    return cookieData;
  } catch (e) {
    showMessage("Gagal mengambil data dari cookie", "error");
  }
};

export const removeData = (storageKey: any) => {
  try {
    Cookies.remove(storageKey);
  } catch (e) {
    showMessage("Gagal menghapus data dari cookie", "error");
  }
};
